import { render, staticRenderFns } from "./vehicleScrap.vue?vue&type=template&id=3cfdfcf1&scoped=true&"
import script from "./vehicleScrap.vue?vue&type=script&lang=js&"
export * from "./vehicleScrap.vue?vue&type=script&lang=js&"
import style0 from "./vehicleScrap.vue?vue&type=style&index=0&id=3cfdfcf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfdfcf1",
  null
  
)

export default component.exports